const ReviewProductVariation = ({ variation }) => (
  <>
    <p className="text-sm text-gray-dark">Varianta produsului</p>

    <div className="flex flex-row md:flex-col lg:flex-row gap-1.5 w-full mt-1.5">
      {variation.map((label, index) => (
        <p
          key={index}
          className="px-2 py-0.5 md:py-1 rounded bg-[#F2F2F2] text-sm text-gray-dark w-max"
        >
          {label}
        </p>
      ))}
    </div>
  </>
);

export default ReviewProductVariation;
